export enum FollowUpStudyErrorCode {
	ValidationError = "VALIDATION_ERROR",
	StudyIncomplete = "STUDY_INCOMPLETE",
	NoChanges = "NO_CHANGES",
	NoEligibleAssignee = "NO_ELIGIBLE_ASSIGNEE",
	StudyVersionConflict = "STUDY_VERSION_CONFLICT",
	ConfirmationRequired = "CONFIRMATION_REQUIRED",
	ReportAlreadyApproved = "REPORT_ALREADY_APPROVED",
	SabrUnavailable = "SABR_UNAVAILABLE",
	NotSabrReport = "NOT_SABR_REPORT",
	CompletionItemNotPending = "COMPLETION_ITEM_NOT_PENDING",
}
